import { cloneDeep } from 'lodash';
import React, { useCallback, useEffect, useState } from 'react';
import styled from 'styled-components';
import { Translate } from '../../../localization/Translate';
import style from './style';
import InputNumberBlur from '../../../../../setup/components/input-number-blur';
import CommandBar from '../../../../../setup/setup-item-editor/command-bar';
import roundedToCents from '../../../../../../util/other/rounded-to-cents';
import useSetup from '../../../../../setup/useSetup';

const Price = ({ product, price, onChange }) => {
  return (
    <tr>
      <td>
        {product.id} / {product.name}
      </td>
      <td>{product.type}</td>
      <td>
        <InputNumberBlur id={product.productRef} value={price ?? ''} onChange={onChange} />
      </td>
      <td>{product.uomCode}</td>
    </tr>
  );
};

const Styled = styled.div`
  ${style}
`;

const OrderCostBookPrices = ({ item, products, onChange, onCancel, onSave }) => {
  const { getCostBook, costBook, itemBusy: costBookLoading } = useSetup();
  const [list, setList] = useState(null);

  const handleGetCostBook = useCallback(async () => {
    try {
      if (item?.crn) {
        await getCostBook(item?.crn);
      }
    } catch (error) {
      console.error('Error fetching cost book:', error);
    }
  }, [getCostBook, item?.crn]);

  useEffect(() => {
    if (products) {
      setList(products);
    }
    handleGetCostBook();
  }, [products, handleGetCostBook]);

  const getPrice = React.useCallback(
    productRef => {
      if (costBookLoading) return '';
      const { price } = costBook?.prices?.find(p => p.productRef === productRef) || { price: { value: '' } };
      return price.value ?? '';
    },
    [costBook?.prices, costBookLoading]
  );

  const changePrice = React.useCallback(
    (id, value) => {
      const prices = cloneDeep(item?.prices || []).filter(p => p.productRef !== id);
      const product = products.find(p => p.productRef === id);
      if (product) {
        const fValue = parseFloat(`${value}`);
        if (!isNaN(fValue)) {
          const price = {
            id: product.id,
            productRef: id,
            price: {
              currencyCode: 'USD',
              uomCode: product.uomCode,
              value: roundedToCents(fValue),
            },
          };

          prices.push(price);
        }

        onChange && onChange('prices', prices);
      }
    },
    [onChange, products, item?.prices]
  );

  return (
    <Styled className="cost-book-prices">
      <div className="table-container">
        <table>
          <thead>
            <tr>
              <th>
                <Translate stringId="product" defaultMessage="Product" />
              </th>
              <th>
                <Translate stringId="type" defaultMessage="Type" />
              </th>
              <th>
                <Translate stringId="price" defaultMessage="Price" />
              </th>
              <th>
                <Translate stringId="uom" defaultMessage="UOM" />
              </th>
            </tr>
          </thead>
          <tbody>
            {list?.map(product => (
              <Price
                key={product.productRef}
                product={product}
                price={getPrice(product.productRef)}
                onChange={changePrice}
              />
            ))}
          </tbody>
        </table>
        <CommandBar
          onSave={onSave}
          onCancel={onCancel}
          typeId="order-cost-book"
          disabled={false}
          busy={costBookLoading}
        />
      </div>
    </Styled>
  );
};

export default OrderCostBookPrices;
